import React, { Component, useEffect, useRef, useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import {Link, useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useOktaAuth} from '@okta/okta-react'

import './Navbar.scss';
import logoImage from 'assets/img/icon_circle-cfa-logo.svg';
import {IOktaUser} from 'interfaces';

export function Navbar() {
    const { t, i18n } = useTranslation();
    const {oktaAuth, authState} = useOktaAuth();
    const [user, setUser] = useState<IOktaUser>();
    let [location, setLocation] = useState('');

    // Load or clear our user info when the user logs in/out.
    // We'll keep track of whether the user was previously authenticated when we rendered last.
    const prevIsAuthedRef = useRef(false);
    useEffect(() => {
        if (!prevIsAuthedRef.current && authState.isAuthenticated) {
            parseOktaUserInfo(authState);
            // If the user has just now been authenticated, we need to load their info the the navbar.
            oktaAuth.token.getUserInfo()
                .then((loadedUser: IOktaUser) => {
                    setUser(loadedUser);
                })
                .catch((err) => {
                    console.log('ERROR fetching user: ', err);
                });
        } else if (prevIsAuthedRef.current && !authState.isAuthenticated) {
            // If the user was authenticated and has just now been logged out, clear our user info.
            setUser(undefined);
        }

        prevIsAuthedRef.current = authState.isAuthenticated;
    }, [authState]);

    const parseOktaUserInfo = (authState) => {
        let claims = authState?.accessToken?.claims;
        if (claims) {
            let userLocation = claims.cfa_loc_list;
            if (userLocation && userLocation.length > 0) {
                // Use hook to assign user location
                setLocation(userLocation[0]);
            } else {
                console.error('No location found in token. authState: ', authState);
            }
        } else {
            console.error('No claims found in token. authState: ', authState);
        }
    }

    const signout = () => {
        oktaAuth.signOut();
    }

    let history = useHistory();
    const routeChange = (path) => { 
        history.push(path);
    }

    return (
        <div className="navbarContainer">
            <div className="navbar">
                <Link to="/" className="navbar_logoSection" data-cy="navBar_logo">
                    <img src={logoImage} className="navbar_logo"/>
                    <span className="navbar_logoText">
                        {t('navbar.appName')}
                    </span>
                </Link>
                <div className="navbar_middleSection"></div>
                {authState.isAuthenticated && (
                    <div className="navbar_userSection">
                        {/* Using bootstrap dropdown with custom styling. */}
                        <Dropdown className="navbar_dropdown" role="menu" navbar={true}>
                            <Dropdown.Toggle id="navbar_user_dropdown" className="navbar_dropdownToggle">
                                <span className="navbar_dropdownLabel">
                                    {t('navbar.userName', {name: user?.name})}
                                </span>
                                <FontAwesomeIcon icon="caret-down" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="navbar_dropdownMenu" alignRight>
                                <Dropdown.Header className="navbar_dropdownHeader">
                                    <div className="navbar_signedInMessage">
                                        {t('navbar.signedInMessage')}
                                    </div>
                                    <div className="navbar_signedInEmail">
                                        {user?.email}
                                    </div>
                                </Dropdown.Header>
                                <Dropdown.Divider />

                                { location == '00000' && (
                                    <>
                                    <Dropdown.Item role="menuitem" as="button" tabIndex={-1} className="navbar_dropdownItem" onClick={() => routeChange("/manufacturers")}>
                                        {t('navbar.manufacturers')}
                                    </Dropdown.Item>
                                    <Dropdown.Item role="menuitem" as="button" tabIndex={-1} className="navbar_dropdownItem" onClick={() => routeChange("/models")}>
                                        {t('navbar.models')}
                                    </Dropdown.Item>
                                    </>
                                )}
                                
                                <Dropdown.Item role="menuitem" as="button" tabIndex={-1} className="navbar_dropdownItem" onClick={() => routeChange("/firmware-versions")}>
                                    {t('navbar.firmwareVersions')}
                                </Dropdown.Item>
                                <Dropdown.Item role="menuitem" as="button" tabIndex={-1} className="navbar_dropdownItem" onClick={signout}>
                                    {t('navbar.signOut')}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
            </div>
        </div>
    );
}